import basicInterface from './basic-interface.js'
import formatInterface from './codec-format-interface.js'
import codecHash from './codec-hash.js'
import codec from './codec.js'

/**
 * Codecs utility from @leofcoin/codecs
 */
export { codecs } from '@leofcoin/codecs'

/**
 * Basic interface for codecs
 */
export const BasicInterface = basicInterface

/**
 * Interface for defining codec formats
 */
export const FormatInterface = formatInterface

/**
 * Codec hash utility class
 */
export const CodecHash = codecHash

/**
 * Codec utility class
 */
export const Codec = codec
